import gql from 'graphql-tag';

export const UPDATE_REGION_ZIPS = gql`
	mutation UpdateRegion($id: String!, $zipCodes: [String]) {
		updateRegion(id: $id, zipCodes: $zipCodes) {
			id
			zipCodes
		}
	}
`;
